import React, { useState } from 'react';
import { Calendar, Clock, CheckCircle2, CalendarSearch, Users, FileText } from 'lucide-react';
import { motion } from 'framer-motion';
export function TourBookingPanel() {
  const [selectedSlot, setSelectedSlot] = useState<string | null>(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const tourSlots = [{
    id: 'tue-10',
    day: 'Tuesday',
    time: '10:00am',
    date: 'Next week'
  }, {
    id: 'wed-14',
    day: 'Wednesday',
    time: '2:00pm',
    date: 'Next week'
  }, {
    id: 'thu-1630',
    day: 'Thursday',
    time: '4:30pm',
    date: 'Next week'
  }];
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Track: lead_form_submit');
    setIsSubmitted(true);
  };
  if (isSubmitted) {
    return <section id="tours" className="py-20 md:py-32 px-6 bg-cream relative overflow-hidden" data-id="element-465">
        {/* Playful blobs */}
        <div className="absolute top-1/2 left-1/4 w-64 h-64 bg-teal/10 rounded-full blur-3xl -translate-y-1/2" data-id="element-466"></div>
        <div className="absolute top-1/2 right-1/4 w-64 h-64 bg-yellow/10 rounded-full blur-3xl -translate-y-1/2" data-id="element-467"></div>

        <div className="max-w-3xl mx-auto bg-white rounded-[24px] shadow-card border border-sand p-16 text-center relative z-10" data-id="element-468">
          <div className="w-24 h-24 bg-teal-light text-teal rounded-full flex items-center justify-center mx-auto mb-8" data-id="element-469">
            <CheckCircle2 size={48} data-id="element-470" />
          </div>
          <h2 className="text-4xl font-extrabold text-navy mb-4" data-id="element-471">
            Tour requested successfully
          </h2>
          <p className="text-xl text-navy/70 mb-10 font-medium" data-id="element-472">
            We've sent a confirmation email and SMS. We'll see you soon at
            Funtastic Kidz.
          </p>
          <button onClick={() => setIsSubmitted(false)} className="text-blue font-bold hover:text-blue-deep underline text-lg" data-id="element-473">
            Book another tour
          </button>
        </div>
      </section>;
  }
  return <section id="tours" className="py-20 md:py-32 px-6 bg-cream relative overflow-hidden" data-id="element-474">
      {/* Playful blobs */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-475">
        <div className="absolute top-20 -left-20 w-96 h-96 bg-blue/5 rounded-full blur-3xl" data-id="element-476"></div>
        <div className="absolute bottom-20 -right-20 w-96 h-96 bg-coral/5 rounded-full blur-3xl" data-id="element-477"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-478">
        <div className="text-center mb-16" data-id="element-479">
          <h2 className="text-3xl md:text-5xl font-extrabold text-navy mb-6 tracking-tight" data-id="element-480">
            Book a centre tour — three slots this week.
          </h2>
          <p className="text-lg md:text-xl text-navy/70 font-medium max-w-2xl mx-auto" data-id="element-481">
            Walk the rooms, meet the educators, ask anything. 30 minutes. No
            enrolment pressure.
          </p>
        </div>

        <div className="grid lg:grid-cols-12 gap-8 items-start" data-id="element-482">
          {/* Form Side */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="lg:col-span-8 bg-white rounded-[24px] shadow-card border border-sand overflow-hidden" data-id="element-483">
            <div className="p-8 md:p-10 border-b border-sand bg-sand/10" data-id="element-484">
              <h3 className="font-extrabold text-navy text-xl" data-id="element-485">Your Details</h3>
            </div>
            <div className="p-8 md:p-10" data-id="element-486">
              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-487">
                <div className="grid md:grid-cols-2 gap-6" data-id="element-488">
                  <div className="space-y-2" data-id="element-489">
                    <label htmlFor="parentName" className="block text-sm font-bold text-navy" data-id="element-490">
                      Parent name
                    </label>
                    <input type="text" id="parentName" required className="w-full h-14 px-4 rounded-xl border-2 border-sand bg-cream focus:outline-none focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all font-medium text-navy" data-id="element-491" />
                  </div>
                  <div className="space-y-2" data-id="element-492">
                    <label htmlFor="phone" className="block text-sm font-bold text-navy" data-id="element-493">
                      Phone
                    </label>
                    <input type="tel" id="phone" required className="w-full h-14 px-4 rounded-xl border-2 border-sand bg-cream focus:outline-none focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all font-medium text-navy" data-id="element-494" />
                  </div>
                </div>

                <div className="space-y-2" data-id="element-495">
                  <label htmlFor="email" className="block text-sm font-bold text-navy" data-id="element-496">
                    Email
                  </label>
                  <input type="email" id="email" required className="w-full h-14 px-4 rounded-xl border-2 border-sand bg-cream focus:outline-none focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all font-medium text-navy" data-id="element-497" />
                </div>

                <div className="grid md:grid-cols-2 gap-6" data-id="element-498">
                  <div className="space-y-2" data-id="element-499">
                    <label htmlFor="childAge" className="block text-sm font-bold text-navy" data-id="element-500">
                      Child's age
                    </label>
                    <select id="childAge" required className="w-full h-14 px-4 rounded-xl border-2 border-sand bg-cream focus:outline-none focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all font-medium text-navy appearance-none" data-id="element-501">
                      <option value="" data-id="element-502">Select age</option>
                      <option value="0-1" data-id="element-503">6 weeks - 12 months</option>
                      <option value="1-2" data-id="element-504">1 - 2 years</option>
                      <option value="2-3" data-id="element-505">2 - 3 years</option>
                      <option value="3-5" data-id="element-506">3 - 5 years</option>
                    </select>
                  </div>
                  <div className="space-y-2" data-id="element-507">
                    <label htmlFor="careNeeded" className="block text-sm font-bold text-navy" data-id="element-508">
                      Care needed
                    </label>
                    <select id="careNeeded" required className="w-full h-14 px-4 rounded-xl border-2 border-sand bg-cream focus:outline-none focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all font-medium text-navy appearance-none" data-id="element-509">
                      <option value="" data-id="element-510">Select timing</option>
                      <option value="asap" data-id="element-511">ASAP</option>
                      <option value="1-3mo" data-id="element-512">1-3 months</option>
                      <option value="3-6mo" data-id="element-513">3-6 months</option>
                      <option value="research" data-id="element-514">Just researching</option>
                    </select>
                  </div>
                </div>

                <div className="space-y-3" data-id="element-515">
                  <label className="block text-sm font-bold text-navy" data-id="element-516">
                    Days needed per week
                  </label>
                  <div className="flex flex-wrap gap-3" data-id="element-517">
                    {[1, 2, 3, 4, 5].map(num => <label key={num} className="cursor-pointer" data-id="element-518">
                        <input type="radio" name="days" value={num} className="peer sr-only" data-id="element-519" />
                        <div className="w-14 h-14 rounded-xl border-2 border-sand bg-cream flex items-center justify-center font-bold text-lg text-navy peer-checked:bg-blue peer-checked:text-white peer-checked:border-blue transition-all shadow-sm peer-checked:shadow-md" data-id="element-520">
                          {num}
                        </div>
                      </label>)}
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-6" data-id="element-521">
                  <div className="space-y-2" data-id="element-522">
                    <label htmlFor="suburb" className="block text-sm font-bold text-navy" data-id="element-523">
                      Suburb
                    </label>
                    <input type="text" id="suburb" required className="w-full h-14 px-4 rounded-xl border-2 border-sand bg-cream focus:outline-none focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all font-medium text-navy" data-id="element-524" />
                  </div>
                  <div className="space-y-2" data-id="element-525">
                    <label htmlFor="ccs" className="block text-sm font-bold text-navy" data-id="element-526">
                      Used CCS before?
                    </label>
                    <select id="ccs" required className="w-full h-14 px-4 rounded-xl border-2 border-sand bg-cream focus:outline-none focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all font-medium text-navy appearance-none" data-id="element-527">
                      <option value="" data-id="element-528">Select</option>
                      <option value="yes" data-id="element-529">Yes</option>
                      <option value="no" data-id="element-530">No</option>
                      <option value="unsure" data-id="element-531">Not sure</option>
                    </select>
                  </div>
                </div>

                <div className="space-y-2" data-id="element-532">
                  <label htmlFor="message" className="block text-sm font-bold text-navy" data-id="element-533">
                    Message (optional)
                  </label>
                  <textarea id="message" rows={3} className="w-full p-4 rounded-xl border-2 border-sand bg-cream focus:outline-none focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all font-medium text-navy resize-y" data-id="element-534"></textarea>
                </div>

                <label className="flex items-start gap-3 cursor-pointer group pt-2" data-id="element-535">
                  <input type="checkbox" required className="mt-1 w-5 h-5 rounded border-sand text-blue focus:ring-blue" data-id="element-536" />
                  <span className="text-sm font-medium text-navy/70 group-hover:text-navy transition-colors" data-id="element-537">
                    I agree to the privacy policy and consent to being contacted
                    about my enquiry.
                  </span>
                </label>

                <button type="submit" className="w-full bg-coral text-white h-16 rounded-btn font-extrabold text-lg hover:bg-red transition-colors shadow-lg hover:shadow-xl hover:-translate-y-1 transform duration-200 mt-6 animate-pulse-cta" data-id="element-538">
                  Book My Tour
                </button>
                <p className="text-center text-sm font-medium text-navy/50 mt-4" data-id="element-539">
                  No sales pressure. We answer in 4 business hours or less,
                  weekdays.
                </p>
              </form>
            </div>
          </motion.div>

          {/* Sidebar: Slots + Merged Enrolment Steps */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="lg:col-span-4 space-y-8" data-id="element-540">
            {/* Slots */}
            <div className="bg-white rounded-[24px] shadow-card border border-sand overflow-hidden" data-id="element-541">
              <div className="p-6 border-b border-sand bg-blue text-white" data-id="element-542">
                <h3 className="font-extrabold text-xl" data-id="element-543">Select a time</h3>
              </div>
              <div className="p-6 space-y-4" data-id="element-544">
                {tourSlots.map(slot => <button key={slot.id} type="button" onClick={() => setSelectedSlot(slot.id)} className={`w-full text-left p-5 rounded-xl border-2 transition-all duration-200 ${selectedSlot === slot.id ? 'border-blue bg-blue/5 shadow-md transform scale-[1.02]' : 'border-sand bg-cream hover:border-blue/30 hover:bg-white'}`} data-id="element-545">
                    <div className="flex items-center justify-between mb-2" data-id="element-546">
                      <span className="font-extrabold text-navy text-lg" data-id="element-547">
                        {slot.day}
                      </span>
                      {selectedSlot === slot.id && <CheckCircle2 size={20} className="text-blue" data-id="element-548" />}
                    </div>
                    <div className="flex items-center gap-2 text-navy/80 font-medium mb-1" data-id="element-549">
                      <Clock size={16} className="text-coral" data-id="element-550" />
                      <span data-id="element-551">{slot.time}</span>
                    </div>
                    <div className="flex items-center gap-2 text-navy/50 text-sm font-medium" data-id="element-552">
                      <Calendar size={16} data-id="element-553" />
                      <span data-id="element-554">{slot.date}</span>
                    </div>
                  </button>)}

                <div className="pt-4 mt-2 border-t border-sand" data-id="element-555">
                  <p className="text-sm font-medium text-navy/70 text-center" data-id="element-556">
                    Can't make these times? <br data-id="element-557" />
                    <a href="tel:0387143350" className="text-blue font-bold hover:text-blue-deep underline mt-1 inline-block" data-id="element-558">
                      Call us
                    </a>{' '}
                    to arrange another time.
                  </p>
                </div>
              </div>
            </div>

            {/* Merged Enrolment Steps */}
            <div className="bg-sand/30 rounded-[24px] p-8 border border-sand relative overflow-hidden" data-id="element-559">
              {/* Warm decorative image behind steps */}
              <div className="absolute -bottom-10 -right-10 w-48 h-48 opacity-10 mix-blend-multiply pointer-events-none" data-id="element-560">
                <img src="https://cdn.magicpatterns.com/uploads/qoZ6jM3fKXWK3u4d1KwCec/shot-of-a-teacher-singing-with-her-preschool-children.jpg" alt="Teacher with children" className="w-full h-full object-cover rounded-full" data-id="element-561" />
              </div>

              <h3 className="font-extrabold text-navy text-lg mb-6 relative z-10" data-id="element-562">
                What happens next?
              </h3>
              <div className="space-y-6 relative z-10 before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-sand before:to-transparent" data-id="element-563">
                <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-564">
                  <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-cream bg-teal text-white font-bold text-sm shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2" data-id="element-565">
                    1
                  </div>
                  <div className="w-[calc(100%-3rem)] md:w-[calc(50%-2.5rem)] p-4 rounded-xl bg-white shadow-sm border border-sand" data-id="element-566">
                    <h4 className="font-bold text-navy text-sm mb-1" data-id="element-567">
                      Tour the centre
                    </h4>
                    <p className="text-xs text-navy/70 font-medium" data-id="element-568">
                      Walk the rooms, meet educators.
                    </p>
                  </div>
                </div>
                <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-569">
                  <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-cream bg-coral text-white font-bold text-sm shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2" data-id="element-570">
                    2
                  </div>
                  <div className="w-[calc(100%-3rem)] md:w-[calc(50%-2.5rem)] p-4 rounded-xl bg-white shadow-sm border border-sand" data-id="element-571">
                    <h4 className="font-bold text-navy text-sm mb-1" data-id="element-572">
                      Check availability
                    </h4>
                    <p className="text-xs text-navy/70 font-medium" data-id="element-573">
                      Confirm days for your child's age.
                    </p>
                  </div>
                </div>
                <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-574">
                  <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-cream bg-blue text-white font-bold text-sm shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2" data-id="element-575">
                    3
                  </div>
                  <div className="w-[calc(100%-3rem)] md:w-[calc(50%-2.5rem)] p-4 rounded-xl bg-white shadow-sm border border-sand" data-id="element-576">
                    <h4 className="font-bold text-navy text-sm mb-1" data-id="element-577">
                      Enrol + CCS
                    </h4>
                    <p className="text-xs text-navy/70 font-medium" data-id="element-578">
                      We help with the paperwork.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}